<template>
  <div class="home">
    <p class="home-title">ポジショニングマップ.COM</p>
    <h1>
      ポジショニングマップを<br>
      ブラウザ上で作成する<br>
      Webアプリ<br>
    </h1>
    <nav>
      <ul>
        <li class="main">
          <v-btn
            dark
            depressed
            color="primary"
            x-large
            to="/list"
            style="font-size: 24px;"
          >
            作成する
          </v-btn>
        </li>
        <li class="mt-2">
          <v-btn
            text
            color="primary"
            to="/howto"
            x-large
          >
            できること・使い方
          </v-btn>
        </li>
        <li class="mt-2">
          <Crash></Crash>
        </li>
      </ul>
    </nav>
    <p class="desc">ご利用は無料<br>ユーザー登録も不要<br><small>推奨ブラウザ: Chrome, Safari, Firefox</small></p>
    <social-sharing url="https://www.positioning-map.com/"
      title="ポジショニングマップ.COM"
      description="ポジショニングマップを作成するWebアプリ。ご利用は無料。ユーザー登録も不要。"
      quote=""
      hashtags="ポジショニングマップ,positioning,Webアプリ"
      twitter-user=""
      inline-template>
      <div
        class="d-flex justify-space-between pt-4 pb-8 mx-auto"
        style="width: 120px;"
      >
        <network network="facebook">
          <i class="mdi mdi-facebook" style="color: #3B5998; font-size: 46px;"></i>
        </network>
        <network network="twitter">
          <i class="mdi mdi-twitter" style="color: #1DA1F2; font-size: 46px;"></i>
        </network>
      </div>
    </social-sharing>
    <div class="lang">
      <v-btn text color="primary" to="/en">English</v-btn>
    </div>
    <nav class="mt-8">
      <ul>
        <li>
          <v-btn
            color="white"
            text
            to="/about"
          >
            <v-icon color="primary">mdi-arrow-right</v-icon>
            <span class="link-text">ポジショニングマップ.COMについて</span>
          </v-btn>
        </li>
        <li>
          <v-btn
            color="white"
            text
            to="/developer"
          >
            <v-icon color="primary">mdi-arrow-right</v-icon>
            <span class="link-text">開発者について</span>
          </v-btn>
        </li>
        <li>
          <v-btn
            color="white"
            text
            to="/terms"
          >
            <v-icon color="primary">mdi-arrow-right</v-icon>
            <span class="link-text">利用規約</span>
          </v-btn>
        </li>
      </ul>
    </nav>
    <Demo
      v-if="false"
      class="thanks"
    ></Demo>
    <div class="thanks">
      <v-btn
        text
        color="teal"
        tag="a"
        href="/v1/"
      >
        旧版はこちら
      </v-btn>
    </div>
    <div class="copyright">
      <small>&copy; www.positioning-map.com</small>
    </div>
  </div>
</template>

<script>
import Demo from '@/components/Demo'
import Crash from '@/components/Crash'

export default {
  metaInfo: {
    title: 'ポジショニングマップ.COM | Webアプリ',
    meta: [
      { name: 'description', content: 'ポジショニングマップをブラウザで作成するツールです。ご利用は無料。ユーザー登録も不要。' }
    ]
  },
  components: {
    Demo,
    Crash
  },
  mounted () {
    this.$i18n.locale = 'ja'
  }
}
</script>

<style lang="scss">
.home {
  text-align: center;
  line-height: 1;
  background-color: #fff;
  margin-top: 40px;
  .home-title {
    line-height: 1.8;
    font-size: 32px;
    font-weight: bold;
    margin: 20px auto;
  }
  h1 {
    font-size: 18px;
    line-height: 1.6;
    margin-top: 16px;
    line-height: 2.6;
    font-weight: normal;
  }
  .desc {
    font-size: 18px;
    line-height: 1.6;
    margin-top: 16px;
  }
  ul {
    list-style: none;
    padding-left: 0 !important;
  }
  .main {
    margin: 40px auto 0;
    .desc {
      margin-top: 12px;
      line-height: 1.5;
      font-size: 16px;
    }
  }
  .lang {
    margin: 0 auto 16px;
  }
  .link-text {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
  }
  .thanks {
    position: absolute;
    top: 4px;
    right: 4px;
  }
  .copyright {
    margin: 60px 0 20px;
  }
}
</style>
